import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-right",
  "use": "icon-chevron-right-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-chevron-right\"><path d=\"M1.5 13L.1 11.6l5.1-4.9L0 1.3 1.4 0 8 6.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol